import { render, staticRenderFns } from "./ExpedientecontenidoFormPage.vue?vue&type=template&id=08d94758&"
import script from "./ExpedientecontenidoFormPage.vue?vue&type=script&lang=js&"
export * from "./ExpedientecontenidoFormPage.vue?vue&type=script&lang=js&"
import style0 from "./ExpedientecontenidoFormPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports